import {
  kiesActueleKlantbronBasis,
  type InboxBronBerichtInvoer,
  type InboxBronGesprek,
} from './effectieve-klantbron';

/** Eén browserveilige bronkeuze voor alle store- en UI-paden. */
export function actueleKlantbronId(
  messages: readonly InboxBronBerichtInvoer[],
  gesprek: InboxBronGesprek = {},
): string | null {
  const resultaat = kiesActueleKlantbronBasis(messages, gesprek);
  return resultaat.status === 'gevonden' ? resultaat.bron.bericht.id : null;
}

/** De backend bindt een concept aan exact de actuele effectieve klantbron. */
export function actieBronId(
  messages: readonly InboxBronBerichtInvoer[],
  gebondenId: string | null,
  gesprek: InboxBronGesprek = {},
): string | null {
  const actueleId = actueleKlantbronId(messages, gesprek);
  return gebondenId && gebondenId === actueleId ? gebondenId : null;
}
